import React, { useContext } from 'react';
import { DataContext } from '../data/DataContext';
import { DataContextType } from '../data_types/interfaces';
import { Container } from '@mui/material';
import NoData from '../../routes/NoData';
import Loading from '../layout/Loading';

interface MinimalLayoutWithDataProps {
    children: any;
}

const MinimalLayoutWithData: React.FC<MinimalLayoutWithDataProps> = ({ children })=> {
    const context = useContext<DataContextType | undefined>(DataContext);
    const { currentSeason, playerData, deleteConfirmed } = context || {};

    if (currentSeason === '') {
        return <Loading />;
    }

    if (!playerData && !deleteConfirmed) {
        return <NoData />;
    }

    return (
        <Container maxWidth="xs">
            { children }
        </Container>
    );
};

export default MinimalLayoutWithData;
